// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--648ca";
export var wrapper = "contact-module--wrapper--759f2";